export default {
  getReferences: (state) => (objectType) => state.referencesCache[objectType] || [],

  getLinkedNames: (state) => (objectType) => state.linkedNamesCache[objectType] || {},
};
